// extracted by mini-css-extract-plugin
module.exports = {"information":"tpiL3Qs6","title":"__88U7Ba0b","description":"E4UnsDdy","link":"di6ldxKR","videoTitle":"E2BKCgyc","card":"z7ohWRng"};